import * as http from 'axios'
const defaultEndpoint = require('@/endpoint')

export const getEspecialidades = (q) =>
  http.get(`${defaultEndpoint.urlGrupoSin}/api/Especialidade?sort=nome&nome__regex=/.*${q}.*/i`)



// WEBPACK FOOTER //
// ./src/store/especialidadeRede/services.js